import React, { useState } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import DashboardLayout from "../../layouts/DashboardLayout";
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";

import EmailAccountsTab from "./Tabs/EmailAccountsTab";
import EmailTab from "./Tabs/EmailTab";

const TabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`simple-tabpanel-${index}`}
    aria-labelledby={`simple-tab-${index}`}
    {...other}
  >
    {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
  </div>
);

const EmailsPage = () => {
  const [tabValue, setTabValue] = useState(1);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <DashboardLayout>
      <MDBox>
        <MDTypography variant="h4" fontWeight="medium" color="dark" mb={3}>
          Email Management
        </MDTypography>

        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={tabValue} onChange={handleTabChange}>
            <Tab label="Email Accounts" />
            <Tab label="Emails" />
          </Tabs>
        </Box>

        {/* Email Accounts Tab */}
        <TabPanel value={tabValue} index={0}>
          <EmailAccountsTab />
        </TabPanel>

        {/* Emails Tab */}
        <TabPanel value={tabValue} index={1}>
          <EmailTab />
        </TabPanel>
      </MDBox>
    </DashboardLayout>
  );
};

export default EmailsPage;
